// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import ElementUI from "element-ui"; // 2.1引入结构
import "element-ui/lib/theme-chalk/index.css"; // 2.2引入样式

import App from "./App";
import router from "./router";
// import store from './vuex/store'

import store from "./store/index.js";

// 请求
import axios from "axios";
import qs from "qs";
// import VueAxios from 'vue-axios'
Vue.prototype.$ajax = axios;
Vue.prototype.$qs = qs;
// Vue.use(VueAxios,axios)
axios.defaults.baseURL = "http://66.6.71.84:8081/data/monitor";
// axios.defaults.baseURL='https://cnodejs.org/api/v1'

// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    undefined;
    console.info("给所有接口添加请求头");
    console.info(config.headers);
    console.info(store.state.token);
    // 在发送请求之前做些什么
    //判断是否存在token，如果存在将每个页面header都添加token
    //if中的值为登陆时存入vuex中的token值
    //如果存在token值，将token放入请求头‘x-auth-token’中
    if (store.state.token) {
      undefined;
      config.headers.common["x-auth-token"] = encodeURIComponent(
        store.state.token
      );
      // encodeURIComponent() 函数对 URI 组件进行编码。
      // 此函数对特殊字符进行编码。此外，它还对以下字符进行编码： , / ? : @ & = + $ #
      // 提示：请使用 decodeURIComponent() 函数对编码的 URI 组件进行解码。

      // config.params={'token':encodeURIComponent(store.state.token)}//如果要求携带在参数中
      // config.headers.Authorization=encodeURIComponent(store.state.token)//如果要求携带在请求头中
    }

    return config;
  },
  (error) => {
    undefined;
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

Vue.use(ElementUI); // 3.安装
// 引入全局css样式
import "./assets/css/global.css";
import "./assets/css/web.css";
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});

// router.beforeEach((to,from,next)=>{
//   console.info('进入------------------token判断')
// 	if(to.meta.requireAuth){
// 		if(store.state.userId){
// 			next()
// 		}else{
// 			next({path:'/b'})
// 		}
// 	}else{
// 		next()
// 	}
// })
// 注册全局钩子用来拦截导航
router.beforeEach((to, from, next) => {
  const token = store.state.token;
  next();
});
// 全局注册一个名为refreshPage的方法
Vue.prototype.$refreshPage = function () {
  console.info("------------");
  location.reload();
};

export default router;



// WEBPACK FOOTER //
// ./src/main.js